import React from 'react';
import Select from "../../../form/select/Select";
import Icon1 from "../../../../assets/images/bitcoin.png";
import Icon2 from "../../../../assets/images/ethereum.png";
import Icon3 from "../../../../assets/images/litecoin.png";
import Icon4 from "../../../../assets/images/ripple.png";
import Input from "../../../form/Input";
import Button from "../../../form/Button";
import logo from "../../../../assets/images/logo.png";
import Image from "../../../elements/Image";

const Buy = () => {
  return (
    <div className="relative flex flex-col h-full  overflow-y-auto ">
      <div className="relative items-center border border-gray-200 rounded-lg ">
        <div className="relative flex items-center border-b border-gray-200 p-4">
          <Select
            xPlacement={'bottomRight'}
            dropdownButtonClass={'!rounded-none !w-28 !bg-transparent !border border-gray-200 !rounded !text-shades-09 uppercase !text-base font-medium px-2'}
            dropdownClass={'!w-10'}
            optionsClass={"!text-sm"}
            dropdownData={[
              { _id: 1, image: Icon1, name: 'BTC', value: 1 },
              { _id: 2, image: Icon2, name: 'ETH', value: 2 },
              { _id: 3, image: Icon3, name: 'LTC', value: 3 },
              { _id: 4, image: Icon4, name: 'XRP', value: 4 }, 
            ]}
            selectedValue={1}
          />
          <div className="relative">
            <Input
              inputType="number"
              label={"Pay with Dollars"}
              labelClasses={"!text-shades-05 text-xs text-right"}
              inputClasses={"bg-transparent !text-2xl !border-none !border-slate-200 rounded-lg !text-right !h-8 !py-2 !pr-0"}
              inputPlaceholder={"000"}
              placeholderClass={"!text-sm"}
            />
          </div>
        </div>
        <div className="relative  flex items-center   rounded-lg p-4">
          <Select
            xPlacement="bottomRight"
            dropdownButtonClass="!rounded-none !w-28 !bg-transparent !border border-gray-200 !rounded !text-shades-09 uppercase !text-base font-medium px-2"
            dropdownClass="!w-10 !text-xl !uppercase"
            dropdownData={[
              { _id: 1, image: Icon1, name: "UTC", value: 1, class: "uppercase text-base" },
              { _id: 2, image: Icon2, name: "ETH", value: 2, class: "uppercase text-base" },
              { _id: 3, image: Icon3, name: "LTC", value: 3, class: "uppercase text-base" },
              { _id: 4, image: Icon4, name: "XRP", value: 4, class: "uppercase text-base" },
            ]}
            selectedValue={1}
          />

          <div className="relative">
            <Input
              label={"Buy Bitcoin"}
              labelClasses={"!text-shades-05 text-xs text-right"}
              inputClasses={"bg-transparent !text-2xl !border-none !border-slate-200 rounded-lg !text-right !h-8 !py-2 !pr-0"}
              inputPlaceholder={"000"}
              placeholderClass={"!text-sm"}
            />
          </div>
        </div>
      </div>
      <div className="relative flex items-center justify-between mt-3">
        <div className="relative">
          <Select
            xPlacement={'bottomRight'}

            dropdownButtonClass={'!rounded-none !w-42 !bg-transparent !border-none !text-shades-09  !text-base font-medium px-2'}
            dropdownClass={'!w-10 !mb-2'}
            optionsClass={"!text-sm"}
            dropdownData={[
              { _id: 1, name: 'Fees included', value: 1 },
              { _id: 2, name: 'Fees included saw', value: 2 },
            ]}
            selectedValue={1}
          />
        </div>
        <div className="text-sm uppercase text-shades-05 !w-auto">
          <p> 5 BTC≈569,487.40004 USD</p>
        </div>
      </div>
      <div className="relative">
        <Button
          buttonClasses={"!h-12 xls:!h-14 !rounded-xl !px-4 md:!px-8 !border !border-primaryBorder  !w-full uppercase mt-10 font-semibold text-base xl:!text-lg"}
          buttonHasLink={false}
          buttonType={'button'}
          buttonLabel={"Continue"}
          buttonLabelClasses={""}
        />
      </div> 
    </div>
  )
}

export default Buy;
